export default "__VITE_ASSET__vUCtAgkJ__"